
import React, {Component} from 'react';
import './container_m.css';

class Container extends Component {
    state = {}

    useMe = () => {
        
    }

    render() {
        const {component: C, ...props} = this.props
        return (
                <div className="owncontainer_m">
                <C {...props} />
            </div>
        )
    }
}

export function withContainer(component) {
    return function(props) {
        return (
            <Container component={component} {...props}/>
        )
    }
}